import { render, staticRenderFns } from "./PendingVerification.vue?vue&type=template&id=230af328"
import script from "./PendingVerification.vue?vue&type=script&lang=ts"
export * from "./PendingVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports